module.exports = __webpack_public_path__ + "img/grundung-3.1230af44.jpg";